//////////////////
// IMPORTS
//////////////////

// libraries
import React from "react";
import { useQuery } from "@apollo/client";
import { Match } from "found";

import { WebSettingsOrganizationMembersQueryDocument } from "./__generated__/WebSettingsOrganizationMembers.generated";

// components
import { WebSettingsContainer } from "../web-settings-container";
import { AdminPanelBillingGroupsMembersContainer } from "@components/admin-panel/admin-panel-view/admin-panel-billing-groups-members";

// constants
// import { paths } from "@clockwise/client-commons/src/constants/site";

// util
import { getCurrentOrg } from "@util/org.util";
import { page, PageEvents } from "@util/analytics.util";
import { logger } from "@util/logger.util";

// material-ui
// import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Web Settings Organization Members
// ~-~-~-~-~-~-~-
interface IProps {
  match: Match;
}

export const WebSettingsOrganizationMembers = (props: IProps) => {
  React.useEffect(() => {
    page(PageEvents.WEB_SETTINGS_ORGANIZATION_MEMBERS);
  }, []);

  const { loading, data, error } = useQuery(WebSettingsOrganizationMembersQueryDocument);

  if (error) {
    logger.error(`failed to load WebSettingsOrganizationMembers: ${error}`);
    return (
      <WebSettingsContainer>
        An error occurred while loading Clockwise:
        <br />
        {error.message}
      </WebSettingsContainer>
    );
  }

  if (!data || loading) {
    return <WebSettingsContainer>Loading…</WebSettingsContainer>;
  }

  const viewer = data.viewer;
  const org = getCurrentOrg(viewer);

  if (!org) {
    return <WebSettingsContainer>Loading…</WebSettingsContainer>;
  }

  const primaryBillingGroupId =
    (org.featureGrid.__typename === "FeatureGrid" &&
      org.featureGrid.stateMetadata.primaryBillingGroupMetadata?.billingGroup.id) ||
    undefined;

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  return (
    <WebSettingsContainer>
      <AdminPanelBillingGroupsMembersContainer
        orgRelayId={org.id}
        match={props.match}
        primaryBillingGroupId={primaryBillingGroupId}
      />
    </WebSettingsContainer>
  );
};
